import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import { Accordion, AccordionItem } from 'react-sanfona';


class Section11 extends Component {
  render() {
    return (
      <section id="page_11">
        <div className="container">
          <div className="row">
            <div className="col-sm-offset-3 col-sm-6 col-xs-12">
              <div className="title text-center">
                よくあるご質問
              </div>
              <div className="paragraph">
                <div className="sub_title">
                  一般
                </div>
                <Accordion allowMultiple={true}>

                  <AccordionItem title={"Q. どのくらいの英語のレベルや年齢の人向けですか？"}>
                    <div className="answer">
                      A. Musio Academy Planは、主に英語学習の初級者から中級者までのサービスとなっています。
                      Musioとリスニング・スピーキングの勉強をすることで、英語に慣れ、会話がアップし、実践的な英語力を楽しく身につけることができます。
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>

              <div className="paragraph">
                <div className="sub_title">
                  コースについて
                </div>
                <Accordion allowMultiple={true}>

                  <AccordionItem title={"Q. Musioは何台必要ですか？"}>
                    <div className="answer">
                      A. Musioの必要台数は授業の内容によって異なりますが、1～2人につき1台が目安です。
                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. Basicコースに加入したのですが、生徒が5名以上の場合はどうすればいいですか？"}>
                    <div className="answer">
                      A. Basicコースは、お試しコースでございます。5名以上のコースをご希望の場合は、
                      Premiumコースへのご加入をご検討ください。
                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. コースの選択はなにがありますか？"}>
                    <div className="answer">
                      A. コースの種類は、BasicコースとPremiumコースに、それぞれ1ヶ月単位と年間単位が選択できます。
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>

              <div className="paragraph">
                <div className="sub_title">
                  Musioについて
                </div>
                <Accordion allowMultiple={true}>

                  <AccordionItem title={"Q. Musioを体験できますか？"}>
                    <div className="answer">
                      A. Musio Store（明治神宮前・原宿）または一部の家電量販店や百貨店の売り場でご体験いただけます。
                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. Musioを使うにはどのような環境が必要ですか？"}>
                    <div className="answer">
                      A. Wi-Fiネットワーク環境が必要です。また、以下の規格にご留意ください。<br/>
                      ネットワークの規格：WPA/WPA2-PSK暗号化ネットワーク<br/>
                      ルーター/モデムの規格：2.4GhzのB/G/Nルーター
                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. Musioが故障した場合、どうすればいいですか？"}>
                    <div className="answer">
                      A. ユーザーガイドに従った通常の使用時における初期不良・故障の場合は、無料で修理・交換します。
                      お客様の不注意による故障による修理・交換が必要な場合は、修理・交換費用をお支払いいただきます。
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>

              <div className="paragraph">
                <div className="sub_title">
                  Musio Storeについて
                </div>
                <Accordion allowMultiple={true}>
                  <AccordionItem title={"Q. どこにありますか？"}>
                    <div className="answer">
                      A. 明治神宮前駅から徒歩3分、原宿駅から徒歩10分程度のところにございます。<br />
                      住所：東京都渋谷区神宮前4丁目28番4号 ARES GARDEN OMOTESANDO 2階
                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. 予約制ですか？"}>
                    <div className="answer">
                      A. Musioのご予約の制度はございません。
                         Musio Storeで行なっている法人様向けの「Musio活用セミナー」
                         はご予約制となっておりますので、ご興味のある方は下記リンク先をご参照ください。<br/>
                         <a href="https://blog.themusio.com/2018/04/30/musio-store-may-information/">
                          https://blog.themusio.com/2018/04/30/musio-store-may-information/
                         </a>
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>

              <div className="paragraph">
                <div className="sub_title">
                  コンテンツについて
                </div>
                <Accordion allowMultiple={true}>
                  <AccordionItem title={"Q. どんなコンテンツがありますか？"}>
                    <div className="answer">
                      A. Musioのコンテンツには、ビジネスシーンや日常生活の会話・表現、
                      小学校から高校までに学習する単語、TOEICや実用英語技能検定の単語があります。

                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. 最大いくつまでコンテンツを追加できますか？"}>
                    <div className="answer">
                      A. 無限に追加していただけます。
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>

              <div className="paragraph">
                <div className="sub_title">
                  お支払いについて
                </div>
                <Accordion allowMultiple={true}>
                  <AccordionItem title={"Q. お支払方法を教えてください。"}>
                    <div className="answer">
                      A. お支払方法は２つございます。<br />
                      ①クレジットカード決済 <br />
                       &emsp;翌月の1日に当月分が決済されます。
                      <br />
                      <br />
                      ②請求書払い<br />
                       &emsp;翌月の1日に請求書が発行され、当月分を月末までに入金していただきます。
                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. コースの選択によって、自動更新はありますか？"}>
                    <div className="answer">
                      A. 単月コースは、毎月自動更新となります。<br />
                      年間契約の場合は、自動更新はございません。
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>

              <div className="paragraph">
                <div className="sub_title">
                  変更・解約について
                </div>
                <Accordion allowMultiple={true}>
                  <AccordionItem title={"Q. 解約するにはどうすればいいですか？"}>
                    <div className="answer">
                      A. 同月内でしたら、「解約キャンセル」が可能です。
                      「解約キャンセル」は 会員ページにログインし、「ご注文・お申し込み一覧」の[詳細]ボタンよりお手続きください。
                    </div>
                  </AccordionItem>

                  <AccordionItem title={"Q. 解約料は発生しますか？"}>
                    <div className="answer">
                      A. 解約料は発生しません。<br />
                      &emsp;契約期間中に途中解約をされた場合でも残月分の返金はいたしませんのでご了承ください。

                    </div>
                  </AccordionItem>
                </Accordion>
              </div>


            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section11;



// WEBPACK FOOTER //
// ./src/sections/Section11.js